import React from 'react';
import { Button } from '~/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

interface Props {
  className?: string;
  url: string;
}

const GeneralConditionsButton: React.FC<Props> = ({ className, url }) => {
  return (
    <Button
      variant="tertiary"
      className={className}
      onPress={() => MarisaAppUtils.openUrl(url)}
    >
      VISUALIZAR PDF COM AS CONDIÇÕES DO SEGURO
    </Button>
  );
};

export default GeneralConditionsButton;
